import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import MarkedReact from 'marked-react';
import { Divider } from '../../primitives/Divider/index.js';
import { Link } from '../../primitives/Link/index.js';
import { CopyToClipboardButton } from '../../primitives/Markdown/components/CopyToClipboard.js';
import { Headline } from '../../primitives/Markdown/components/Headline.js';
import { List } from '../../primitives/Markdown/components/List.js';
import { ListItem } from '../../primitives/Markdown/components/ListItem.js';
import { Notice } from '../../primitives/Markdown/components/Notice.js';
import { Paragraph } from '../../primitives/Markdown/components/Paragraph.js';
import { HeadlineLarge, HeadlineMedium, HeadlineSmall, LabelSmallBold } from '../../primitives/Typography/index.js';
import { SPACING_NONE } from '../../utils/spacingLegacy.js';
export const Markdown = ({
  isInline,
  value,
  copyToClipboardButtonProps
}) => {
  return _jsx(MarkedReact, {
    isInline: isInline,
    value: value,
    renderer: {
      link: (href, text) => {
        if (href.startsWith('copy://')) {
          return _jsx(CopyToClipboardButton, {
            ...copyToClipboardButtonProps,
            value: decodeURIComponent(href.slice(7)),
            children: text
          });
        }
        return _jsx(Link, {
          href: href,
          target: "_blank",
          children: text
        });
      },
      hr: () => _jsx(Divider, {}),
      paragraph: children => _jsx(Paragraph, {
        children: children
      }),
      heading: (children, level) => {
        switch (level) {
          case 1:
            {
              return _jsx(Headline, {
                as: HeadlineLarge,
                children: children
              });
            }
          case 2:
            {
              return _jsx(Headline, {
                as: HeadlineMedium,
                children: children
              });
            }
          case 3:
            {
              return _jsx(Headline, {
                as: HeadlineSmall,
                children: children
              });
            }
          default:
            {
              return _jsx(Headline, {
                children: children
              });
            }
        }
      },
      list: (children, ordered) => {
        return _jsx(List, {
          spacing: SPACING_NONE,
          as: ordered ? 'ol' : 'ul',
          children: children
        });
      },
      listItem: children => _jsx(ListItem, {
        size: "medium",
        children: children
      }),
      blockquote: children => _jsx(Notice, {
        variant: "info",
        children: children
      }),
      strong: children => _jsx(LabelSmallBold, {
        as: "span",
        children: children
      })
    }
  });
};